(function(){
  var mounted = false;

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var themeMoneyFormat = (window.Shopify && Shopify.money_format) || "€{{amount}}";
  function fmt(cents){
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, themeMoneyFormat);
    return (cents/100).toLocaleString(undefined,{minimumFractionDigits:2, maximumFractionDigits:2}) + ' €';
  }

  var PRICE_SELECTORS = [
    '[data-product-price] .price-item--regular',
    '.product__price .price-item--regular',
    '.product__price .price__current',
    '.product__price [data-product-price]',
    '.price__current',
    '.product-meta__price .price-item--regular',
    '.product .price .price__current'
  ];
  function setThemePriceText(txt){
    for (var i=0;i<PRICE_SELECTORS.length;i++){
      var el = document.querySelector(PRICE_SELECTORS[i]);
      if (el){ el.textContent = txt; return true; }
    }
    return false;
  }

  function getMainVariantId(){
    // 1) dans le form
    var idField = (document.querySelector('form[action*="/cart/add"]') || document).querySelector('input[name="id"], select[name="id"]');
    if (idField && idField.value) return parseInt(idField.value,10);
    // 2) global (certains thèmes exposent ça)
    if (window.meta && meta.product && meta.product.variants){
      var sv = meta.selectedVariantId || (meta.product.selected_or_first_available_variant && meta.product.selected_or_first_available_variant.id);
      if (sv) return parseInt(sv,10);
    }
    // 3) balise JSON Shopify classique
    try{
      var el = document.querySelector('script[type="application/json"][data-product]');
      if (el){
        var p = JSON.parse(el.textContent);
        if (p && p.variants && p.variants[0] && p.variants[0].id) return parseInt(p.variants[0].id,10);
      }
    }catch(e){}
    return null;
  }

  function initOnce(){
    if (mounted) return;

    var qtyWrap   = document.getElementById('pc-qty');
    var upsellWrap= document.getElementById('pc-upsell');
    if (!qtyWrap || !upsellWrap) return;

    var form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('[data-product-form]');
    if(!form) return;

    mounted = true;

    // ====== UI ======
    var qtyInput = form.querySelector('input[name="quantity"]');
    if(!qtyInput){ qtyInput = document.createElement('input'); qtyInput.type='hidden'; qtyInput.name='quantity'; qtyInput.value='1'; form.appendChild(qtyInput); }

    var tierBtns = Array.from(qtyWrap.querySelectorAll('.pc-tier'));
    tierBtns.forEach(function(btn){
      var final = parseInt(btn.dataset.final||'0',10);
      var compare = parseInt(btn.dataset.compare||'0',10);
      var cf = btn.querySelector('.pc-tier__final');
      var cc = btn.querySelector('.pc-tier__compare');
      if (cf) cf.textContent = fmt(final||0);
      if (cc) cc.textContent = compare ? fmt(compare) : '';
    });
    function selectedTier(){
      return tierBtns.find(function(b){ return b.getAttribute('aria-checked')==='true'; }) || tierBtns[0] || null;
    }

    var upsellCheck     = upsellWrap.querySelector('#pc-upsell-check');
    var upsellPriceEl   = upsellWrap.querySelector('#pc-upsell-price');
    var upsellPriceOne  = parseInt(upsellWrap.dataset.upsellPriceOne||'0',10);
    var upsellFreeLabel = upsellWrap.dataset.upsellFreeLabel || 'Offerte';
    var upsellHandle    = upsellWrap.dataset.upsellHandle || null;
    var upsellVariantId = upsellWrap.getAttribute('data-upsell-variant-id')
      ? parseInt(upsellWrap.getAttribute('data-upsell-variant-id'),10)
      : null;

    function compute(){
      var t = selectedTier(); if(!t) return {qty:1, productTotal:0, upsell:0, grand:0};
      var qty = parseInt(t.dataset.qty||'1',10);
      var final = parseInt(t.dataset.final||'0',10);
      var upsellCost = (upsellCheck && upsellCheck.checked && qty === 1) ? upsellPriceOne : 0;
      return {qty: qty, productTotal: final, upsell: upsellCost, grand: final + upsellCost};
    }
    function paint(){
      var totals = compute();
      qtyInput.value = String(Math.max(1, totals.qty));
      if (upsellPriceEl){
        upsellPriceEl.textContent = (totals.qty >= 2) ? upsellFreeLabel : fmt(upsellPriceOne);
      }
      setThemePriceText(fmt(totals.grand));
    }
    function selectTier(btn){
      tierBtns.forEach(function(b){ b.setAttribute('aria-checked','false'); });
      btn.setAttribute('aria-checked','true');
      paint();
    }
    if (tierBtns[0]) selectTier(tierBtns[0]);
    tierBtns.forEach(function(btn){ btn.addEventListener('click', function(){ selectTier(btn); }); });
    if (upsellCheck){ upsellCheck.addEventListener('change', paint); }

    // ====== ENVOI MULTI-ADD ======
    function postWithUpsell(){
      var mainVariantId = getMainVariantId();
      var qty = parseInt(qtyInput.value||'1',10);

      if (!mainVariantId){
        console.warn('[PC] mainVariantId introuvable');
        return false; // on laisse le thème gérer si on ne sait pas quoi ajouter
      }
      if (!upsellVariantId && upsellHandle){
        // récup à la volée si nécessaire
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        return fetch(root + 'products/' + upsellHandle + '.js')
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(p){ return p && p.variants && p.variants[0] && p.variants[0].id; })
          .then(function(id){ upsellVariantId = id ? parseInt(id,10) : null; return upsellVariantId; })
          .then(function(){
            if (!upsellVariantId) return false;
            var items = [
              { id: mainVariantId, quantity: qty },
              { id: upsellVariantId, quantity: 1, properties: { "_upsell": "petite_boite" } }
            ];
            console.log('[PC] /cart/add.js items=', items);
            return fetch('/cart/add.js', {
              method:'POST', headers:{'Content-Type':'application/json'},
              body: JSON.stringify({ items: items })
            }).then(function(){ return true; });
          });
      } else if (upsellVariantId){
        var items = [
          { id: mainVariantId, quantity: qty },
          { id: upsellVariantId, quantity: 1, properties: { "_upsell": "petite_boite" } }
        ];
        console.log('[PC] /cart/add.js items=', items);
        return fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ items: items })
        }).then(function(){ return true; });
      } else {
        // pas d'upsell id ni handle → rien à faire ici
        return false;
      }
    }

    // 1) Intercepter SUBMIT (si le thème soumet vraiment)
    form.addEventListener('submit', function(e){
      if(!(upsellCheck && upsellCheck.checked)) return; // pas de case → natif
      e.preventDefault();
      var p = postWithUpsell();
      if (p && typeof p.then === 'function'){
        p.then(function(done){
          if (done){
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function(){
              if (!document.querySelector('.drawer--is-open') && !document.body.classList.contains('cart-open')) {
                window.location.href = '/cart';
              }
            }, 200);
          } else {
            form.submit(); // fallback
          }
        }).catch(function(){ form.submit(); });
      } else {
        form.submit();
      }
    }, true); // capture = true pour passer avant le JS du thème

    // 2) Intercepter le CLIC sur le bouton "Ajouter au panier" (si le thème ne fait pas de submit)
    var addBtn = form.querySelector('button[name="add"], [type="submit"][name="add"], .product-form__submit');
    if (addBtn){
      addBtn.addEventListener('click', function(e){
        if(!(upsellCheck && upsellCheck.checked)) return; // pas de case → natif
        // Certains thèmes ne déclenchent pas "submit" → on gère ici
        e.preventDefault();
        var p = postWithUpsell();
        if (p && typeof p.then === 'function'){
          p.then(function(done){
            if (done){
              document.dispatchEvent(new CustomEvent('cart:refresh'));

            } else {
              form.submit();
            }
          }).catch(function(){ form.submit(); });
        } else {
          form.submit();
        }
      }, true); // capture
    }
  }

  ready(initOnce);
  document.addEventListener('shopify:section:load', function(){ mounted = false; initOnce(); });
  document.addEventListener('shopify:section:select', function(){ mounted = false; initOnce(); });
  var mo = new MutationObserver(function(){
    if (!mounted && (document.getElementById('pc-qty') || document.getElementById('pc-upsell'))) {
      initOnce();
    }
  });
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();
